export default __webpack_public_path__ + "static/media/arrow-left.95320d2e.svg";